// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './routes/Home';
import Empleo from './routes/Empleo';
import Contacto from './routes/Contacto';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/empleo" element={<Empleo />} />
        <Route path="/contacto" element={<Contacto/>}/>
      </Routes>
    </Router>
  );
}

export default App;
